/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Shop_Tier_Discount_InvalidInputs */

const vi_shop_tier_discount_invalid = /** @type {(inputs: Shop_Tier_Discount_InvalidInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ưu đãi tối đa ${i?.max}%, tối đa 2 chữ số thập phân.`)
};

/**

* @param {Shop_Tier_Discount_InvalidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_tier_discount_invalid = /** @type {((inputs: Shop_Tier_Discount_InvalidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Tier_Discount_InvalidInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_tier_discount_invalid(inputs)
});